import { z } from "zod";

export const overlayTextItemSchema = z.object({
	id: z.string(),
	text: z.string().max(200),
	x: z.number().min(0).max(1),
	y: z.number().min(0).max(1),
	color: z.string().optional(),
	italic: z.boolean().optional(),
	backgroundColor: z.string().nullable().optional(),
	fontSize: z.number().min(10).max(80).optional(),
});

export type OverlayTextItem = z.infer<typeof overlayTextItemSchema>;

export const overlayTextsSchema = z.array(overlayTextItemSchema).max(10).optional();

export const overlayTextsNullableSchema = z.array(overlayTextItemSchema).max(10).nullable().optional();
